import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    banner: {
        width: '100%',
        background: '#147D64',
        height: '28px',
        textAlign: 'center',
        color: '#E1F9EE',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '0.75rem',
        lineHeight: '133%',
        paddingTop: '12px',
    },
    user: {
        textTransform: 'capitalize',
        fontWeight: '600',
    },
}));

const ImpersonationBanner = ({ user }) => {
    const { fullName } = user;
    const classes = useStyles();
    return (
        user &&
        fullName && (
            <div className={classes.banner}>
                You are impersonating <span className={classes.user}>{fullName}</span>
            </div>
        )
    );
};

export default ImpersonationBanner;
